export const ellipsisFunction = (text, text_limit = 15) => {
    if (text) {
        if (text.length > text_limit)
            return text.substring(0, text_limit) + '...';
        else return text;
    } else return text;
}